export function isModuleEnabled(userData: any, moduleName: string): boolean {
    if (!userData?.currentModules) {
        return false;
    }
    return Boolean(userData.currentModules[moduleName]);
}

